import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/base/api-base.service';
import { PromotionalBannerInterface } from '../interfaces/promotional-banner.interface';
import { environment } from '@environments/environment';
import { combineLatest, map, Observable, shareReplay, switchMap } from 'rxjs';
import { PromotionalBannerModel } from '../models/promotional-banner.model';
import { ProductsService } from '@core/services/products.service';
import { ArrayOrder, sortProps } from '@core/utils/array.util';

@Injectable({
  providedIn: 'root',
})
export class PromotionalBannersService extends ApiBaseService<PromotionalBannerInterface> {
  private readonly _promotionalBanners$: Observable<PromotionalBannerModel[]> = combineLatest([
    this._productsService.productsIdx$,
  ]).pipe(
    switchMap(([productsIdx]) =>
      this.dataStatic$.pipe(
        map((banners) => banners.map((pb) => new PromotionalBannerModel(pb, productsIdx))),
      ),
    ),
    map((promoBanners) => promoBanners.filter((pb) => pb.visible)),
    shareReplay(),
  );

  public readonly mainBanner$: Observable<PromotionalBannerModel | null> =
    this._promotionalBanners$.pipe(
      map(
        (promoBanners) =>
          sortProps(
            promoBanners.filter((pb) => pb.isMain),
            ['validFrom'],
            ArrayOrder.desc,
          )[0] || null,
      ),
    );

  public readonly secondaryBanner$: Observable<PromotionalBannerModel | null> =
    this._promotionalBanners$.pipe(
      map(
        (promoBanners) =>
          sortProps(
            promoBanners.filter((pb) => !pb.isMain),
            ['validFrom'],
            ArrayOrder.desc,
          )[0] || null,
      ),
    );

  constructor(private _productsService: ProductsService) {
    super({
      static: {
        url: `${environment.apiStatic}home_banners`,
      },
    });
  }
}
